import { render, staticRenderFns } from "./ModelToolTile.vue?vue&type=template&id=08b44dbc&scoped=true&"
import script from "./ModelToolTile.vue?vue&type=script&lang=js&"
export * from "./ModelToolTile.vue?vue&type=script&lang=js&"
import style0 from "./ModelToolTile.vue?vue&type=style&index=0&id=08b44dbc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b44dbc",
  null
  
)

export default component.exports